<template>
  <div class="investment-reg__card-body">
    <div class="investment-reg__card-header">Твоя ниша</div>

    <div class="investment-reg__card-text">
      Расскажи о нише, на которой планируешь привлечь инвестиции для Миллиона с
      Аязом, а также о конкурентах в ней
    </div>

    <form class="investment-reg__card-form" @submit.prevent="updateNiches">
      <UiNumberInput
        v-model="$v.investmentsInfo.pointA.$model"
        title="Точка А, ₽"
        :differ-zero="true"
        :show-empty="false"
        :allow-minus="false"
        placeholder="Сумма для захода на МсА"
        :error="
          $v.investmentsInfo.pointA.$dirty && $v.investmentsInfo.pointA.$invalid
        "
        :popup="
          invalidPopup(
            $v.investmentsInfo.pointA.$dirty,
            $v.investmentsInfo.pointA.$invalid,
            'Обязательное поле'
          )
        "
      />
      <UiNumberInput
        v-model="$v.investmentsInfo.pureProfit.$model"
        title="Чистая прибыль, ₽"
        :differ-zero="true"
        :show-empty="false"
        :allow-minus="false"
        placeholder="Чистая прибыль в месяц"
        :error="
          $v.investmentsInfo.pureProfit.$dirty &&
          $v.investmentsInfo.pureProfit.$invalid
        "
        :popup="
          invalidPopup(
            $v.investmentsInfo.pureProfit.$dirty,
            $v.investmentsInfo.pureProfit.$invalid,
            'Обязательное поле'
          )
        "
      />

      <div
        v-for="(v, index) in $v.investmentsInfo.niches.$each.$iter"
        :key="index"
        class="card-form__niche-block fill-row"
      >
        <div class="niche-header fill-row">
          <div class="niche-header__text">Ниша {{ nicheIndex(v.$model) }}</div>
          <Icon
            v-if="canDeleteNiche"
            icon="delete"
            class="niche-header__icon"
            @click="removeNiche(v.$model)"
          />
        </div>

        <UiInput
          v-model="v.name.$model"
          class="fill-row"
          title="Название ниши"
          placeholder="Укажи название ниши"
          :error="v.name.$dirty && v.name.$invalid"
          :popup="namePopup(index)"
        />
        <UiTextarea
          v-model="v.description.$model"
          class="fill-row"
          title="Описание ниши"
          placeholder="Расскажи про свою нишу"
          :error="v.description.$dirty && v.description.$invalid"
          :popup="descriptionPopup(index)"
        />
        <div class="fill-row text">
          Есть ли конкуренты которые запустились меньше 1 г. назад в городе,
          который похож на твой и зарабатывают столько, сколько ты хочешь?
        </div>
        <div class="radio-set">
          <UiRadio
            :val="v.hasRivals.$model"
            :value="true"
            @input="v.hasRivals.$model = true"
          >
            Да
          </UiRadio>
          <UiRadio
            :val="v.hasRivals.$model"
            :value="false"
            @input="v.hasRivals.$model = false"
          >
            Нет
          </UiRadio>
        </div>
      </div>

      <UiButton
        class="investment-reg__btn-icon"
        color="blue-gray"
        :disabled="!canAddNiches"
        @click="addNiche()"
      >
        <Icon icon="plus-circle" class="investment-reg__icon_btn" />
        Добавить ещё нишу
      </UiButton>
      <UiButton :disabled="!canProceed" type="submit"> Продолжить </UiButton>
    </form>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('ratingInvestmentsRegistration');

export default {
  name: 'NichePage',
  data: () => ({}),
  validations: {
    investmentsInfo: {
      pointA: {
        required,
        maxLength: maxLength(16),
        defined: v => v !== undefined && v !== null,
        positive: v => v >= 0
      },
      pureProfit: {
        required,
        maxLength: maxLength(16),
        defined: v => v !== undefined && v !== null,
        positive: v => v >= 0
      },
      niches: {
        $each: {
          name: {
            required,
            maxLength: maxLength(100)
          },
          description: {
            required,
            maxLength: maxLength(300)
          },
          hasRivals: {
            required
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      investmentsInfo: state => state.data.investmentsInfo
    }),
    canAddNiches: function () {
      return this.investmentsInfo.niches.length < 4;
    },
    canDeleteNiche: function () {
      return this.investmentsInfo.niches.length > 1;
    },
    canProceed: function () {
      return !this.$v.investmentsInfo.$invalid;
    }
  },
  methods: {
    addNiche() {
      this.$store.commit('ratingInvestmentsRegistration/addEmptyNiche');
    },
    removeNiche(niche) {
      this.$store.commit(
        'ratingInvestmentsRegistration/removeNiche',
        this.investmentsInfo.niches.indexOf(niche)
      );
    },
    nicheIndex(niche) {
      return this.investmentsInfo.niches.indexOf(niche) + 1;
    },
    async updateNiches() {
      if (this.canProceed) {
        const nichesUpdated = await this.$store.dispatch(
          'ratingInvestmentsRegistration/updateNiches'
        );
        const profitsUpdated = await this.$store.dispatch(
          'ratingInvestmentsRegistration/updateProfits'
        );

        if (nichesUpdated && profitsUpdated) {
          this.$emit('next', 'FinishPage');
        }
      }
    },
    invalidPopup(isDirty, isInvalid, errorMessage) {
      if (!isDirty) {
        return;
      }
      if (isInvalid) {
        return {
          msg: errorMessage,
          error: isInvalid
        };
      }
    },
    namePopup(index) {
      if (!this.$v.investmentsInfo.niches.$each[index].name.required) {
        return this.invalidPopup(
          this.$v.investmentsInfo.niches.$each[index].name.$dirty,
          this.$v.investmentsInfo.niches.$each[index].name.$invalid,
          'Обязательное поле'
        );
      } else if (!this.$v.investmentsInfo.niches.$each[index].name.maxLength) {
        return this.invalidPopup(
          this.$v.investmentsInfo.niches.$each[index].name.$dirty,
          this.$v.investmentsInfo.niches.$each[index].name.$invalid,
          'Максимальная длина названия - 100 символов'
        );
      } else {
        return {};
      }
    },
    descriptionPopup(index) {
      if (!this.$v.investmentsInfo.niches.$each[index].description.required) {
        return this.invalidPopup(
          this.$v.investmentsInfo.niches.$each[index].description.$dirty,
          this.$v.investmentsInfo.niches.$each[index].description.$invalid,
          'Обязательное поле'
        );
      } else if (
        !this.$v.investmentsInfo.niches.$each[index].description.maxLength
      ) {
        return this.invalidPopup(
          this.$v.investmentsInfo.niches.$each[index].description.$dirty,
          this.$v.investmentsInfo.niches.$each[index].description.$invalid,
          'Максимальная длина описания - 300 символов'
        );
      } else {
        return {};
      }
    }
  }
};
</script>
